let fallbackLineIdCounter = 0;

export const createSumatorLineId = (): string => {
    const uuid = globalThis.crypto?.randomUUID?.();
    if (uuid) {
        return uuid;
    }

    fallbackLineIdCounter += 1;
    return `sumator-${Date.now()}-${fallbackLineIdCounter}`;
};
